// Type imports
import type React from 'react'

// External imports
import styled from '@emotion/styled'
import { useInView } from 'react-intersection-observer'

// Misc
import { CenteredSection, Title } from '../CenteredSection'

// Constant imports
import { DEFAULT } from '../../font'
import { MOBILE_WIDTH_PX } from '../../constants'
import { BaseLocalizedProps } from './types'

const Description = styled.p`
  ${DEFAULT['600']}
  margin: 0 0 64px 0;
  color: ${(props): string => props.theme.outwrite.colors.gray[300]};

  @media screen and (max-width: ${MOBILE_WIDTH_PX}px) {
    ${DEFAULT[200]}
  }
`

const IN_VIEW_OPTIONS = { triggerOnce: true, initialInView: false, delay: 500, threshold: 0.7 }

const Testimonials: React.FC<BaseLocalizedProps> = ({ t, tOptions }) => {
  const { ref: textRef, inView: textInView } = useInView(IN_VIEW_OPTIONS)

  return (
    <CenteredSection bgColor='black'>
      <div
        ref={textRef}
        style={{
          transform: textInView ? 'translateY(0)' : 'translateY(50px)',
          opacity: textInView ? 1 : 0,
          transition: 'transform .25s cubic-bezier(0, 0, 0.2, 1), opacity .25s'
        }}
      >
        <Title>{t('ACKNOWLEDGEMENT_OF_COUNTRY_TITLE', tOptions)}</Title>
        <Description>{t('ACKNOWLEDGEMENT_OF_COUNTRY', tOptions)}</Description>
      </div>
    </CenteredSection>
  )
}

export default Testimonials
